import { AccountState } from "Types/state";
import { AccountResponses, AccountRoutes, API } from "../types";
import { createAPIAction } from "./util";

export interface AccountAction {
    type: API.Account;
    route: AccountRoutes;
    data: AccountObject;
}

type AccountObject = GetAccountObject;
interface GetAccountObject {
    account_slug: string;
}

export interface GetAccountResponseSuccessAction {
    data: AccountState;
    type: AccountResponses.GetSuccess;
}

export interface GetAccountResponseErrorAction {
    account: string;
    data: any;
    type: AccountResponses.GetError;
}

const createAccountAction = (data: AccountObject, route: AccountRoutes): AccountAction =>
    createAPIAction(data, route)(API.Account) as AccountAction;

export const getAccountFromSlug = (slug: string): AccountAction =>
    createAccountAction({ account_slug: slug }, AccountRoutes.GetAccount);
